import { enumRecordToCheckboxOptions } from '@umss/shared/utils';
import { BadgeVariant } from '@umss/shared/utils';

export interface Payment {
  createdAt: string;
  updatedAt: string;
  id: string;
  contractorId: string;
  contractorName: string;
  timesheetId: string;
  paymentAmount: number;
  referralBonusAmount: number;
  totalPaymentAmount: number;
  paymentDate: string | null;
  status: string;
  statusDisplay: string;
  paymentMethod: string;
  paymentReference: string | null;
  weekStartDate: string;
  weekEndDate: string;
  facilityName: string;
  retryCount: number;
  maxRetries: number;
  nextRetryAt: string | null;
  failureReason: string | null;
}

export enum BillingStatus {
  PENDING = 'Pending',
  PAID = 'Paid',
  CANCELLED = 'Cancelled',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  PROCESSING = 'Processing'
}

export const BillingStatusRecord: Record<BillingStatus, string> = {
  [BillingStatus.PENDING]: 'Pending',
  [BillingStatus.PAID]: 'Paid',
  [BillingStatus.CANCELLED]: 'Cancelled',
  [BillingStatus.APPROVED]: 'Approved',
  [BillingStatus.REJECTED]: 'Rejected',
  [BillingStatus.PROCESSING]: 'Processing'
};

export const BILLING_STATUS_BADGE_PROPS: Record<
  BillingStatus,
  { label: string; iconName: string; variant: BadgeVariant; outlined: boolean }
> = {
  [BillingStatus.PENDING]: {
    label: BillingStatusRecord[BillingStatus.PENDING],
    iconName: 'phosphorClockCountdown',
    variant: 'neutral',
    outlined: true
  },
  [BillingStatus.PAID]: {
    label: BillingStatusRecord[BillingStatus.PAID],
    iconName: 'phosphorCheckCircle',
    variant: 'success',
    outlined: true
  },
  [BillingStatus.CANCELLED]: {
    label: BillingStatusRecord[BillingStatus.CANCELLED],
    iconName: 'phosphorXCircle',
    variant: 'warning',
    outlined: true
  },
  [BillingStatus.APPROVED]: {
    label: BillingStatusRecord[BillingStatus.APPROVED],
    iconName: 'phosphorCheckCircle',
    variant: 'success',
    outlined: true
  },
  [BillingStatus.REJECTED]: {
    label: BillingStatusRecord[BillingStatus.REJECTED],
    iconName: 'phosphorXCircle',
    variant: 'error',
    outlined: true
  },
   [BillingStatus.PROCESSING]: {
    label: BillingStatusRecord[BillingStatus.PROCESSING],
    iconName: 'phosphorHourglass',
    variant: 'info',
    outlined: true
  }
};

export const BILLING_STATUS_OPTIONS =
  enumRecordToCheckboxOptions(BillingStatusRecord);
